"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
require("@oneloop/fonts");
var _excluded = ["variant", "isNotButton"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Badge = exports.Badge = function Badge(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? ['badgeNormal', 'primary'] : _ref$variant,
    isNotButton = _ref.isNotButton,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: isNotButton ? '' : 'button',
    tx: "buttons",
    variant: variant
  }, props, {
    __css: {
      lineHeight: '14px',
      display: 'inline-block',
      fontSize: '10px',
      fontFamily: 'primary',
      textAlign: 'center',
      fontWeight: 'bold',
      border: 0,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'static'
    }
  }));
};